export const projects = () => {
    const projectData =  [
        {
            image: '/images/mr-clima-the-weatherapp.png',
            title: 'Mr. Clima',
            description: "A weather app that views the weather details and conditions of a particular location or city specified by the user",
            link: "https://mr-clima-the-weatherapp.netlify.app/" 
        },

        {
            image: '/images/project_explorer.png',
            title: 'Project Explorer',
            description: "Project Explorer is a React and NodeJS app. It is a repository for final year projects across all departments at your instituition. You can submit your project and search projects submitted by others to learn from. The full features and functionalities are not yet available.",
            link: "https://j0shcodes-project-explorer.herokuapp.com/"
        },

        {
            image: '/images/dropout-analytic-tool.png',
            title: 'Dropout Analytic Tool',
            description: "Dropout analytic tool is a react app use to analyse the likely chance of high school students in South African most especially girls dropping out of high school based on some parameters.",
            link: "https://dropout-analytic-tool.netlify.app/"
        },

        {
            image: '/images/whitelist-dapp.png',
            title: 'Whitelist DApp',
            description: "This is a whitelist dapp built on the Ethereum testnet, Rinkeby, for a NFT collection.",
            link: "https://techusiastic-whitelist-dapp.vercel.app/"
        },

        {
            image: '/images/my-portfolio.png',
            title: 'Personal portfolio Website',
            description: "My personal portfolio website. If you are seeing this, you are probably on the website already. Hope you do like it.",
            link: "https://joshua-moses.netlify.app/"
        }
    ]

    return projectData;
}